import { render, staticRenderFns } from "./BadgeUpgrade.vue?vue&type=template&id=255dad99&scoped=true"
import script from "./BadgeUpgrade.vue?vue&type=script&lang=js"
export * from "./BadgeUpgrade.vue?vue&type=script&lang=js"
import style0 from "./BadgeUpgrade.vue?vue&type=style&index=0&id=255dad99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255dad99",
  null
  
)

export default component.exports